import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { AvailabilityClusterMap } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getHotelAvailabilitySearchLocation,
  getFilteredHotelAvailabilityLodgings,
  getMapBound,
  getHotelAvailabilitySearchLocationResult,
  getHotelAvailabilitySortOption,
  getHotelAvailabilityLodgingIdHovered,
  getHotelAvailabilityLodgingIdInFocus,
  getSearchedNightCount,
  getViewHotelsNearLocation,
  getViewHotelsNearAvailabilityProperties,
  getViewedHotelListProperties,
  getHotelAvailabilityCentroids,
  getMapBound as getSearchedMapBound,
  getHotelAvailabilityCallState,
  getHotelAvailabilitySearchBoundingBox,
} from "../../reducer/selectors";
import { actions } from "../../actions";

import { getHotelQueryParams } from "../../reducer";
import { getRoomsCount } from "../../../search/reducer";
import {
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const visibleLodgings = getFilteredHotelAvailabilityLodgings(state);
  const availabilityCallState = getHotelAvailabilityCallState(state);
  const searchLocation = getHotelAvailabilitySearchLocation(state);
  const listHoveredLodgingId = getHotelAvailabilityLodgingIdHovered(state);
  const listSelectedLodgingId = getHotelAvailabilityLodgingIdInFocus(state);
  const isVentureX = !!getRewardsAccounts(state).find((acc) =>
    acc.productDisplayName.includes("Venture X")
  );
  const searchMapBound = getSearchedMapBound(state);
  const searchedNightCount = getSearchedNightCount(state);
  const accountReferenceId =
    getSelectedAccountReferenceIdIfRedemptionEnabled(state);
  const largestValueAccount = getRewardsAccountWithLargestEarnForBanner(state);
  const viewHotelsNearLocation = getViewHotelsNearLocation(state);
  const viewHotelsNearAvailabilityProperties =
    getViewHotelsNearAvailabilityProperties(state);
  const searchCentroids = getHotelAvailabilityCentroids(state);
  const searchBoundingBox = getHotelAvailabilitySearchBoundingBox(state);
  const mapBounds = getMapBound(state);
  const hotelQueryParams = getHotelQueryParams(state);
  const searchLocationResult = getHotelAvailabilitySearchLocationResult(state);
  const sortOrder = getHotelAvailabilitySortOption(state);
  const roomsCount = getRoomsCount(state);

  return {
    lodgings: visibleLodgings,
    availabilityCallState,
    searchLocation,
    searchMapBound,
    listHoveredLodgingId,
    listSelectedLodgingId,
    isVentureX,
    searchedNightCount,
    accountReferenceId,
    largestValueAccount,
    viewHotelsNearLocation,
    viewHotelsNearAvailabilityProperties,
    searchCentroids,
    searchBoundingBox,
    mapBounds,
    hotelQueryParams,
    searchLocationResult,
    sortOrder,
    roomsCount,
    viewedHotelListProperties: getViewedHotelListProperties(state), // Tracking properties'
  };
};

const mapDispatchToProps = {
  fetchInitialHotelAvailability: actions.fetchInitialHotelAvailability,
  setSearchMapBound: actions.setMapBound, // We set the map bounds of the current view as the bounds are required during the fetchInitialHotelAvailability call
  fetchViewHotelsNearLocationCategories:
    actions.fetchViewHotelsNearLocationCategories,
  setViewHotelsNearLocation: actions.setViewHotelsNearLocation, // Used by the mobile fullscreen View stays near here takeover
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AvailabilityClusterMapConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedAvailabilityClusterMap = connector(
  withRouter(AvailabilityClusterMap)
);
